// extracted by mini-css-extract-plugin
export default {"clauseHeader":"style_clauseHeader__Nsh+o","clauseWrapper":"style_clauseWrapper__3s0ae"};